// SPDX-License-Identifier: AGPL-3.0-or-later

import {createNamedStringLiteralUnion, withOpenApiType} from '@konvo/schema/src/primitives/SchemaPrimitives';

export const LocaleSchema = withOpenApiType(
	createNamedStringLiteralUnion(
		[
			['en-GB', 'EN_GB', 'English (United Kingdom)'],
			['en-US', 'EN_US', 'English (United States)'],
		] as const,
		'The locale code for the user interface language',
	),
	'Locale',
);
